// extracted by mini-css-extract-plugin
export default {"characterSheetIcon":"styles_characterSheetIcon__NQH1m","shared3dDiceEnabled":"styles_shared3dDiceEnabled__pkhhV","disabled":"styles_disabled__QQt8w"};